export enum PlatformApplicationSource {
  TALENTHUB = 'talenthub',
  APPLICANT_PLATFORM = 'applicant-platform',
  LEAD = 'lead',
  MANUAL_IMPORT = 'manual-import',
  TRANSFER = 'transfer',
  QUICK_APPLY = 'quick-apply',
}
